<script>

    import { toast } from 'bulma-toast'
    import { creditStore, creditsStore, notifyStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import CreditsService from '../$services/credits.service'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deleteCredit() {

        loading = true
        const resp = await CreditsService.deleteCredit($creditStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.remove($creditStore._id)
        notifyStore.set('wallet_updated')

        toast({message: 'Crédito borrado', type: 'is-success'})
        modalStore.close()
    }

</script>

{#if $creditStore}
    <InfoCard subtitle="Crédito">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Estatus" icon="fas fa-info-circle" value={ TranslateMethods.get($creditStore.status) } />
            <InfoField label="Monto" icon="fas fa-dollar-sign" value={ NumeralMethods.cash($creditStore.amount) } bold color="success" />
            <InfoField label="Método" icon="fas fa-wallet" value={ TranslateMethods.get($creditStore.method) } />
            <InfoField label="Referencia" icon="fas fa-hashtag" value={ $creditStore.reference } />
            {#if $creditStore.user?.email}
                <InfoField label="Usuario" icon="fas fa-user" value={ $creditStore.user.name } bold />
                <InfoField label="Correo" icon="fas fa-envelope" value={ $creditStore.user.email } />
            {/if}
            {#if $creditStore.admin?.email}
                <InfoField label="Admin" icon="fas fa-user-shield" value={ $creditStore.admin.name } />
                <InfoField label="Correo admin" icon="fas fa-envelope" value={ $creditStore.admin.email } />
            {/if}
            <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($creditStore.created) } />
            {#if $creditStore.voucher}
                <InfoField label="Voucher" icon="fas fa-file-image">
                    <a class="is-size-6" href={ $creditStore.voucher } target="_blank" rel="noopener noreferrer">
                        <span class="icon is-small mr-1"><i class="fas fa-external-link-alt"></i></span>
                        Descargar
                    </a>
                </InfoField>
            {/if}
        </div>
    </InfoCard>

    <div class="items-end">
        <div class="buttons">
            {#if isPermission($adminStore, 'UsersView.Credit.Delete')}
                <ButtonDelete on:confirm={deleteCredit} { loading } />
            {/if}
            {#if isPermission($adminStore, 'UsersView.Credit.Update')}
                <ButtonModal modalId="credit_update_modal" icon="edit" text="Actualizar" />
            {/if}
        </div>
    </div>
{/if}
